import { marker } from '@jsverse/transloco-keys-manager/marker';
import { Status } from './enums/status.enum';
import { Information } from './information';

export const statusInformations: { [state in Status]: Information } = {
  [Status.BASIC]: {
    title: marker('Information'),
    icon: '@tui.info',
    iconColor: 'text-tertiary',
  },
  [Status.ERROR]: {
    icon: '@tui.circle-alert',
    title: marker('Echec'),
    description: marker("Un problème est survenu lors de l'opération. Veuillez réessayer."),
    iconColor: 'text-status-negative',
  },
  [Status.LOADING]: {
    icon: '@tui.loader',
    title: marker('Chargement ...'),
    description: marker('Veuillez patienter quelques instants ...'),
    iconColor: 'text-text-tertiary',
    iconStyle: 'animate-spin-slow',
  },
  [Status.SUCCESS]: {
    icon: '@tui.circle-check-big',
    title: marker('Succès'),
    description: marker("L'opération a été réalisée avec succès !"),
    iconColor: 'text-status-positive',
  },
  [Status.WARNING]: {
    icon: '@tui.triangle-alert',
    title: marker('Avertissement'),
    iconColor: 'text-status-warning',
  },
};
